import { insumoApi } from '../../utils/api';
import {
  getObjectDataAction,
  createObjectDataPending,
  getListDataAction,
  saveObjectDataAction,
  deleteObjectDataAction,
  getListDeletedDataAction,
  createListDataDeletedPending,
  restoreObjectDataAction,
} from '../../utils/DataAction';

export const get = (id) =>
  getObjectDataAction({
    dataName: 'INSUMO',
    api: insumoApi,
    relUrl: id,
  });

export const getAll = getListDataAction({
  dataName: 'INSUMO',
  api: insumoApi,
  relUrl: '',
});

export const save = (data) =>
  saveObjectDataAction({
    dataName: 'INSUMO',
    api: insumoApi,
    relUrl: '',
    data: data,
  });

export const deleted = (id) =>
  deleteObjectDataAction({
    dataName: 'INSUMO',
    api: insumoApi,
    relUrl: id,
  });

export const getAllDeleted = getListDeletedDataAction({
  dataName: 'INSUMO',
  api: insumoApi,
  relUrl: 'restore',
});

export const restore = (data) =>
  restoreObjectDataAction({
    dataName: 'INSUMO',
    api: insumoApi,
    relUrl: 'restore',
    data: data,
  });

export const setPending = createObjectDataPending('INSUMO');
export const setDeletedPending = createListDataDeletedPending('INSUMO');
